{
    "firebase": {
        "apiKey": "AIzaSyCxpwg0sIZEl965dRI6j4n5ZQ1qc66ktvo",
        "authDomain": "stout-34f11.firebaseapp.com",
        "databaseURL": "https://stout-34f11-default-rtdb.firebaseio.com",
        "projectId": "stout-34f11",
        "storageBucket": "stout-34f11.firebasestorage.app",
        "messagingSenderId": "612210463124",
        "appId": "1:612210463124:web:659ceb4a7c8c5eb1657f81"
    },
    "clientName": "Stout",
    "pdfViewerKey": "67283f8a79954326b334be5361331312",
    "domains": ["stout.flightlinedata.com"],
    "tally_url": "https://tally.so/r/aQ0YE2"
}
